export default class SeasonModel {
  designation = "";
  dateBegin = new Date();
  dateEnd = new Date();
  isCurrent = false;
  agencyId = 0;
}
